// StoreBadges.jsx — Google Play ve Chrome Web Mağazası rozetleri (marka logosu yerine sade ikon).

import React from 'react';
import { CHROME_EXTENSION_URL, PLAY_STORE_URL, withUtm } from '../config/links';
import { logAnalyticsEvent } from '../firebase';
import { useLang } from '../i18n';

const PlayIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#34A853" d="M3.6 2.2 13.4 12l-9.8 9.8a1.6 1.6 0 0 1-.6-1.3V3.5c0-.5.2-1 .6-1.3Z" />
    <path fill="#FBBC04" d="m17 15.6-3.6-3.6L17 8.4l4.1 2.3c1.2.7 1.2 1.9 0 2.6L17 15.6Z" />
    <path fill="#EA4335" d="M17 15.6 13.4 12l-9.8 9.8c.4.4 1.1.5 1.8.1L17 15.6Z" />
    <path fill="#4285F4" d="M17 8.4 5.4 2.1c-.7-.4-1.4-.3-1.8.1L13.4 12 17 8.4Z" />
  </svg>
);

const ChromeIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <circle cx="12" cy="12" r="11" fill="#fff" />
    <path fill="#EA4335" d="M12 1a11 11 0 0 1 9.5 5.5H12a5.5 5.5 0 0 0-4.8 2.8L3.8 4A11 11 0 0 1 12 1Z" />
    <path fill="#FBBC04" d="M21.5 6.5A11 11 0 0 1 12 23l4.8-8.2A5.5 5.5 0 0 0 16.8 9l4.7-2.5Z" />
    <path fill="#34A853" d="M12 23A11 11 0 0 1 3.8 4l4.7 8.2a5.5 5.5 0 0 0 8.3 2.6L12 23Z" />
    <circle cx="12" cy="12" r="4.2" fill="#4285F4" stroke="#fff" strokeWidth="1.4" />
  </svg>
);

export function PlayBadge({ medium = 'badge' }) {
  const { t } = useLang();
  return (
    <a
      className="store-badge"
      href={withUtm(PLAY_STORE_URL, medium)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => logAnalyticsEvent('store_click', { store: 'play', medium })}
    >
      <PlayIcon />
      <span>
        <small>{t('store.playBadgeSmall')}</small>
        <b>{t('store.playBadge')}</b>
      </span>
    </a>
  );
}

export function ChromeBadge({ medium = 'badge' }) {
  const { t } = useLang();
  return (
    <a
      className="store-badge"
      href={withUtm(CHROME_EXTENSION_URL, medium)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => logAnalyticsEvent('store_click', { store: 'chrome', medium })}
    >
      <ChromeIcon />
      <span>
        <small>{t('store.chromeBadgeSmall')}</small>
        <b>{t('store.chromeBadge')}</b>
      </span>
    </a>
  );
}

export default function StoreBadges({ medium }) {
  return (
    <div className="d-flex flex-wrap gap-2">
      <PlayBadge medium={medium} />
      <ChromeBadge medium={medium} />
    </div>
  );
}
